module.exports = __webpack_public_path__ + "static/media/woman.063cc9e9.jpg";